<template>
  <div class="auth-layout align-center-container">
    <div class="content-container small">
      <h1 class="logo">
        <img :src="cwsLogo" alt="Atu Rtu" />
      </h1>
      <h2 class="default-form__title center">
        {{ cwsMotto }}
      </h2>
      <router-view />
      <span class="copyrights">
        Copyright ©2020
        <a class="link" href="https://tentelemed.com/" target="blank"
          >Telemedicine Technologies S.A.S.</a
        >
        <br />
        All rights reserved.
      </span>

      <div class="version" v-if="appInfo">
        <p>Version: {{ appInfo.version }}</p>
        <p>Build number: {{ appInfo.build_number }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LayoutAuth",
  computed: {
    ...mapGetters({
      appInfo: "getAppInfo",
      serveParams: "getServerParams",
      cwsLogo: "getCwsLogo",
      cwsMotto: "getCwsMotto",
    }),
  },
  methods: {
    ...mapActions(["APP_INFO_REQUEST"]),
  },
  async created() {
    await this.APP_INFO_REQUEST();
  },
};
</script>

<style lang="scss" scoped>
.default-form__title {
  color: #337799;
  margin-bottom: 28px;
  &.center {
    text-align: center;
  }
}
// auth pages
.logo {
  display: block;
  padding: 5px 20px 20px;
  margin: 0;
  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
}
.copyrights {
  display: block;
  text-align: center;
  padding: 30px 0 10px;
  font-size: 12px;
}
.version {
  text-align: center;
  font-size: 12px;
  padding-top: 30px;
  p {
    margin: 0;
  }
}
.align-center-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e2e2e2;
  flex: 1 1 auto;
  padding: 15px;
}
.content-container {
  &.small {
    max-width: 500px;
    width: 100%;
    margin: 20px auto;
    padding: 20px 25px;
    border-radius: 10px;
    background-color: #fff;
  }
}
</style>
